import type { ComponentType } from '@grafikr/components';

const Component: ComponentType = (node) => {
  const select = node.querySelector('select');

  select.addEventListener('change', () => {
    if (!select.value) {
      return;
    }

    const url = new URL(select.value);

    if (select.value.includes('.myshopify')) {
      // Is a Shopify domain, redirect with path
      url.pathname += window.location.pathname.replace(theme.routes.root, '/').replace('//', '/');
      url.pathname = url.pathname.replace('//', '/');
      url.searchParams.set('intl', '');
    } else {
      // Is not a Shopify domain, redirect without path
      url.pathname = '/';
    }

    window.top.location.href = url.toString();
  });
};

export default Component;
